import React, {useState} from 'react'
import VisitorList from '../../components/kiosk/KioskContent/VisitorsList/VisitorsList'
import Icons from '../../components/Icons'
import Modal from 'react-modal'
import {_L, useLocaleState} from '../../context/LocaleContext'
import styled from 'styled-components'

const ReactModalAdapter = ({className, ...props}) => {
  const contentClassName = `${className}__content`
  const overlayClassName = `${className}__overlay`
  return (
    <Modal
      portalClassName={className}
      className={contentClassName}
      overlayClassName={overlayClassName}
      {...props}
    />
  )
}

const AttendeesList = ({
  addMeetingAttendee,
  removeMeetingAttendee,
  width,
  height,
  meeting
}) => {
  const [showVisitors, setShowVisitors] = useState(false)

  const localeState = useLocaleState()

  const {attendees, room} = meeting
  const {maxCapacity} = room

  const isMaxAttendees = (maxCapacity || 0) === attendees.length


  const onAddAttendee = attendee => {
    // Handle the case where the visitor has just been added
    const {emId, isVisitor, visitorId} = attendee
    const hasEmployee = !!emId
    if(!hasEmployee && isVisitor) {
      attendee.emId = visitorId
      attendee.isVisitor = '1'
    }
    addMeetingAttendee(attendee)
    setShowVisitors(false)
  }

  const newVisitorCreated = visitor => onAddAttendee(visitor)

  const getEmptyAttendeeContainers = ({attendeesInRoom, attendees}) => {
    let numberOfContainers = Math.max(attendeesInRoom - attendees.length, 0)
    let containers = Array(numberOfContainers).fill(0)

    return containers.map((item, idx) => <EmptyAttendee key={`empty-${idx}`} />)
  }

  let addAttendee = isMaxAttendees
    ? []
    : [
        <AddUser key={'add'} onClick={() => setShowVisitors(true)}>
          <Icons icon="ADD_ATTENDEE" />
          <AttendeeText>{_L({key: 'Add Attendee', localeState})}</AttendeeText>
        </AddUser>
      ]

  let attendeeItems = attendees.map(attendee => {
    // The attendee can be an employee or visitor
    const {visitorName, visitor_id, emId, name, emTitle} = attendee

    let displayName = visitorName || name
    let key = emId || visitor_id

    return (
      <Attendee key={key}>
        <UserNameText>{displayName}</UserNameText>
        <DeleteIcon onClick={() => removeMeetingAttendee(attendee)}>
          <Icons icon={'DELETE_ATTENDEE'} width={22} height={22} />
        </DeleteIcon>
        <UserTitleText>{emTitle || ''}</UserTitleText>
      </Attendee>
    )
  })

  let emptyAttendee = getEmptyAttendeeContainers(meeting)

  let allAttendees = [...addAttendee, ...attendeeItems, ...emptyAttendee]

  return (
    <Container style={{width, height}}>
      <AttendeesListContainer>{allAttendees}</AttendeesListContainer>
      <StyledModal
        isOpen={showVisitors}
        ariaHideApp={false}
        onRequestClose={() => setShowVisitors(false)}
        contentLabel={_L({key: 'Add attendees', localeState})}
        shouldCloseOnOverlayClick
      >
        <VisitorList
          label={_L({key: 'Select attendee', localeState})}
          onSelectVisitor={onAddAttendee}
          style={{width: '100%'}}
          newVisitorCreated={newVisitorCreated}
        />
      </StyledModal>
    </Container>
  )
}

export default AttendeesList

const StyledModal = styled(ReactModalAdapter)`
  &__overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 40;
    background-color: rgba(18, 21, 32, 0.85);
  }

  &__content {
    top: 40px;
    left: 7vw;
    right: 7vw;
    width: 86vw;
    position: fixed;
    height: calc(100vh - 80px);
  }
`

const Container = styled.div`
  box-sizing: border-box;
  padding: 0 30px 0 30px;
  overflow-y: scroll;
`
const AttendeeText = styled.div`
  font-weight: bold;
  color: #ffffff;
  cursor: pointer;
  user-select: none;
  font-size: 16px;
  padding-left: 16px;
`

const EmptyAttendee = styled.div`
  margin-right: 14px;
  margin-top: 14px;
  width: 230px;
  height: 72px;
  border-radius: 4px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);
  border: dashed 1px #a4a9b7;
  box-sizing: border-box;
`

const AddUser = styled(EmptyAttendee)`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background-color: #3395fe;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: -0.3px;
  color: #ffffff;
  cursor: pointer;
`

const Attendee = styled(EmptyAttendee)`
  background-color: #ffffff;
  border: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  padding-left: 20px;
  box-sizing: border-box;
`

const DeleteIcon = styled.div`
  width: 22px;
  height: 22px;
  cursor: pointer;
  float: right;
  margin-right: -11px;
  margin-top: -47px;
`

const AttendeesListContainer = styled.div`
  display: flex;
  align-content: flex-start;
  flex-wrap: wrap;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
  height: 100%;
`

const UserNameText = styled.div`
  margin-top: 16px;
  font-size: 16px;

  @media (max-width: 420px) {
    margin-top: 14px;
    font-size: 14px;
  }
`
const UserTitleText = styled.div`
  color: #a4a9b7;
  font-size: 14px;
  font-weight: normal;

  @media (max-width: 420px) {
    font-size: 12px;
    line-height: 12px;
  }
`
